var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"editor"},[_c('vue-editor',{ref:"texteditor",attrs:{"editorOptions":_vm.editorSettings,"useCustomImageHandler":""},on:{"image-added":_vm.handleImageAdded},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }